import { render, staticRenderFns } from "./BirthDatepicker.vue?vue&type=template&id=7315316b&scoped=true"
import script from "./BirthDatepicker.vue?vue&type=script&lang=js"
export * from "./BirthDatepicker.vue?vue&type=script&lang=js"
import style0 from "./BirthDatepicker.vue?vue&type=style&index=0&id=7315316b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315316b",
  null
  
)

export default component.exports